import $ from 'jquery';
import pageScripts from './pages/index';
import { Foundation } from 'foundation-sites';
import { Reveal } from 'foundation-sites/js/foundation.reveal';

$(document).foundation();

$(document).ready(function () {
    //Require all components here.
    require('./components/foundation');
});

$(".toggle-content").hide();

$(".arrow-jump").click(function () {
    $(".toggle-content").slideToggle(1000);
    $(".arrow-jump img").toggleClass("opened");
});

$("#slider-owl").owlCarousel({
    loop: true,
    margin: 0,
    responsiveClass: true,
    mouseDrag: true,
    dots: false,
    nav: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    autoplay: true,
    autoplayHoverPause: true,
    responsive: {
        0: {
            items: 1,
        },
        600: {
            items: 1,
        },
        1000: {
            items: 1,
            loop: true
        }
    }
});

$("#brands-owl").owlCarousel({
    loop: true,
    margin: 15,
    responsiveClass: true,
    mouseDrag: true,
    dots: false,
    nav: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    autoplay: false,
    autoplayHoverPause: true,
    responsive: {
        0: {
            items: 2,
        },
        600: {
            items: 4,
        },
        1000: {
            items: 7,
            loop: true
        }
    }
});

$("#product-owl").owlCarousel({
    loop: true,
    margin: 30,
    responsiveClass: true,
    mouseDrag: true,
    dots: false,
    nav: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    autoplay: false,
    autoplayHoverPause: true,
    responsive: {
        0: {
            items: 1,
        },
        600: {
            items: 3,
        },
        1000: {
            items: 4,
            loop: true
        }
    }
});

$("#solution-owl").owlCarousel({
    loop: true,
    margin: 20,
    responsiveClass: true,
    mouseDrag: true,
    dots: false,
    nav: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    autoplay: false,
    autoplayHoverPause: true,
    responsive: {
        0: {
            items: 1,
        },
        600: {
            items: 3,
        },
        1000: {
            items: 4,
            loop: true
        }
    }
});
